import { Injectable } from '@angular/core';
import { confirmResetPassword, type ConfirmResetPasswordInput, resendSignUpCode, ConfirmSignUpInput, autoSignIn, confirmSignUp, fetchAuthSession, getCurrentUser, resetPassword, signOut, signUp, AuthUser, confirmSignIn } from 'aws-amplify/auth';
import { signIn, type SignInInput } from 'aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
export interface ResponseCongito {
  nextStep: any,
  error: any
}
@Injectable({
  providedIn: 'root'
})
export class CognitoService {

  async handleSignUp(username:string, password:string, email:string) {
    const resp = await signUp({
      username,
      password,
      options: {
        userAttributes: {
          email
        },
        // optional
        autoSignIn: true // or SignInOptions e.g { authFlowType: "USER_SRP_AUTH" }
      }
    });
    return resp
  }

  async handleSignUpConfirmation({ username, confirmationCode }: ConfirmSignUpInput) {
    const resp = await confirmSignUp({
      username,
      confirmationCode
    });
    return resp
  }

  async handleSignIn({ username, password }: SignInInput) {
    const session = await signIn({ username, password });
    return session
  }

  async handleSingInConfirmation(code:string) {
    const resp = confirmSignIn({
      challengeResponse: code
    });
    return resp;
  }

  async handleAutoSignIn() {
    const signInOutput = await autoSignIn();
    return signInOutput
  }

  async handleSignOut() {
    try {
      await signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

    async handleResetPassword(username: string) {
      const output = await resetPassword({ username });
      return output;
    }
  
    async handleConfirmResetPassword(username: string, confirmationCode: string, newPassword: string) {
      await confirmResetPassword({ username, confirmationCode, newPassword });
    }

  async handleResendSignUpCode(username: string) {
    const resp = await resendSignUpCode({ username });
    return resp
  }

  async currentSession() {
    try {
      const access = (await fetchAuthSession()).tokens;
      return access
    } catch (err) {
      console.log("Error al recuperar la sesion");
      return err
    }
  }

  async currentAuthenticatedUser() {
    const currentUser: AuthUser = await getCurrentUser();
    return currentUser
  }

  async returnAccesToken() {
    try {
      const token = await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens()
      return token?.accessToken.toString()
    } catch (error) {
      return error
    }
  }

}